import React from 'react';
import { Helmet } from 'react-helmet';

const PageMeta = ({ title , desc = "SenerTech is a leading IT solutions provider specializing in web and app development, AI integration, and CRM systems. We deliver innovative software solutions tailored to your business needs."}) => {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {desc && <meta name="description" content={desc} />}{" "}
    </Helmet>
  );
};

export default PageMeta;
